export default __webpack_public_path__ + "static/media/test2.cfb12636.png";